import { render, staticRenderFns } from "./competencyGroup.vue?vue&type=template&id=c776c288&"
import script from "./competencyGroup.vue?vue&type=script&lang=js&"
export * from "./competencyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports